import { Report, ReportTree, ShowReportsResponse } from "@/models/api/report/Report";
import CancellableHelper from "../CancellableHelper";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import { FILTER_NAMES } from "@/static/filterNames";
import { axiosInstance } from "@/plugins/axios";

export const URL_GET_REPORT_TREE = "/Report/ReportTree";
export const URL_GET_REPORT_TYPES = "/Report/ReportTypes";
export const URL_GET_SHOW_REPORTS = "/Report/ShowReports";
export const URL_GET_GENERATE_REPORT = "/Report/GenerateReport";
export const URL_POST_DELETE_REPORT = "/Report/DeleteReport";
export const URL_GET_FILE = "/File/${FileId}/OpenFile";
export const URL_POST_ASSIGN_REPORT_TYPE_TO_OFFICE_PROFILE = "/Report/AssignReportTypesToOfficeProfile";
export const URL_POST_UNASSIGN_REPORT_TYPE_TO_OFFICE_PROFILE = "/Report/UnassignReportTypesToOfficeProfile";

//#region
const _getReportTree = new CancellableHelper<Array<ReportTree>>(URL_GET_REPORT_TREE, ReportTree);
export const getReportTree = async (): Promise<Array<ReportTree>> => {
  return await _getReportTree.get();
};

const _getReportTypes = new CancellableHelper<Array<Report>>(URL_GET_REPORT_TYPES, Report);
export const getReportTypes = async (officeProfileId: number): Promise<Array<Report>> => {
  return await _getReportTypes.get({ OfficeProfileId: officeProfileId });
};

const _showReports = new CancellableHelper<ShowReportsResponse>(URL_GET_SHOW_REPORTS, ShowReportsResponse);
export const showReports = async (reportType: number, page: number, count: number): Promise<ShowReportsResponse> => {
  return await _showReports.get({
    reportType: reportType,
    page: page,
    count: count,
  });
};

const _generateReport = new CancellableHelper<File>(URL_GET_GENERATE_REPORT);
_generateReport.jsonSerializer = true;
_generateReport.isFile = true;
export const generateReport = async (
  criterions: Array<CriterionItemRequest> | null,
  filterName: FILTER_NAMES,
  reportTypeId: number,
  generatorType: string,
  description: string,
  culture: string,
  password: string
): Promise<void> => {
  const response = await _generateReport.post(
    {
      Criterions: criterions,
      FilterName: filterName,
    },
    {
      ReportTypeId: reportTypeId,
      GeneratorType: generatorType,
      Description: description,
      Culture: culture,
      Password: password,
    }
  );
  const blob = new Blob([response], { type: response.type });
  CancellableHelper.downloadFile(blob, response.name);
};

const _deleteReport = new CancellableHelper<void>(URL_POST_DELETE_REPORT);
export const deleteReport = async (reportId: string): Promise<void> => {
  await _deleteReport.post({ ReportId: reportId }, null);
};

export const downloadReport = async (fileId: string): Promise<void> => {
  const response = await axiosInstance.get(URL_GET_FILE.replace("${FileId}", fileId.toString()), {
    responseType: "blob",
  });
  const blob = new Blob([response.data], {
    type: response.headers["content-type"],
  });
  CancellableHelper.downloadFile(blob, response.headers["content-disposition"] ?? "file");
};

const _assignReportTypeToOfficeProfile = new CancellableHelper<void>(URL_POST_ASSIGN_REPORT_TYPE_TO_OFFICE_PROFILE);
export const assignReportTypeToOfficeProfile = async (
  officeProfileId: number,
  dictionaryItemId: number
): Promise<void> => {
  return _assignReportTypeToOfficeProfile.post(
    { OfficeProfileId: officeProfileId, DictionaryItemId: dictionaryItemId },
    null
  );
};

const _unassignReportTypeToOfficeProfile = new CancellableHelper<void>(URL_POST_UNASSIGN_REPORT_TYPE_TO_OFFICE_PROFILE);
export const unassignReportTypeToOfficeProfile = async (
  officeProfileId: number,
  dictionaryItemId: number
): Promise<void> => {
  return _unassignReportTypeToOfficeProfile.post(
    { OfficeProfileId: officeProfileId, DictionaryItemId: dictionaryItemId },
    null
  );
};

//#endregion
